module.exports = __webpack_public_path__ + "static/media/aida-logo.7d50269a.png";